import { Box, styled } from "@mui/material";

export const MainWrapper = styled(Box)({
  display: "flex",
  "& .right-section": {
    transition: "width 0.3s ease, margin 0.3s ease",
    overflow: "auto",
    flex: 1,
  },
  "& .drawer--open": {
    width: "calc(100% - 250px)",
  },
  "& .drawer--close": {
    width: "calc(100% - 65px)",
  },
  "& main": {
    padding: "10px 20px 15px 20px",
  },
});
